<template>
  <div class="project">
    <el-row type="flex" justify="between" :gutter="5">
      <el-col :span="isCreate ? 24 : 18">
        <div class="grid-content bg-purple-dark">
          <userCard
            :config="cardConfig"
            :isCreate="isCreate"
            @saveSuccess="getData()"
          ></userCard>
        </div>
      </el-col>
      <el-col :span="6" v-if="!isCreate">
        <div class="enclosure">
          <div class="title flex-between">
            <p>{{ $lange == "en" ? "Annex Library" : "附件库" }}</p>
            <el-input
              size="mini"
              type="text"
              style="width: 150px"
              v-model="fileSearchValue"
              @input="fileSearch"
              :placeholder="
                $lange == 'en' ? 'Please Input' : '请输入标题关键字'
              "
            ></el-input>
            <el-button size="mini" @click="showDialog">{{
              $lange == "en" ? "Add" : "添加"
            }}</el-button>
          </div>

          <div class="list-box">
            <div
              class="list flex-between"
              v-for="(item, index) in accessoryInfoList"
            >
              <template v-if="item.redName.indexOf(fileSearchValue) > -1">
                <p>{{ renderDate(item.createTime, "yyyy-MM-dd") }}</p>
                <p
                  class="pdf-name row-clip"
                  v-if="item.redName.length > 0"
                  v-html="item.redName"
                >
                  {{ item.redName }}
                </p>
                <p class="pdf-name row-clip" v-else>{{ item.fileName }}</p>
                <div class="btn-group">
                  <el-button type="text" @click="downloadFile(item)">{{
                    $lange == "en" ? "Download" : "下载"
                  }}</el-button>
                  <el-button
                    type="text"
                    style="color: red"
                    @click="delFile(item, index)"
                    >{{ $lange == "en" ? "Delete" : "删除" }}</el-button
                  >
                </div>
              </template>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <template v-if="!isCreate">
      <el-row type="flex" justify="between" :gutter="5">
        <el-col :span="8">
          <div class="progress-box">
            <div class="title">
              {{
                $lange == "en" ? "Project hours comparison" : "项目工时对比图"
              }}
            </div>
            <div class="show-progress">
              <div class="child progress-default">
                <p>
                  {{ $lange == "en" ? "Estimated" : "预计工时" }}
                  {{ projectChartInfo.estimatedWorkingHours }}小时
                </p>
                <div class="progress-content">
                  <el-progress
                    :percentage="100"
                    :stroke-width="10"
                    :show-text="false"
                  ></el-progress>
                </div>
              </div>
              <div class="child">
                <p>
                  {{ $lange == "en" ? "Actual" : "实际工时" }}
                  {{ projectChartInfo.actualWorkingHours }}小时
                </p>
                <div class="progress-content">
                  <el-progress
                    :percentage="
                      projectChartInfo.estimatedWorkingHours == 0
                        ? 0
                        : (projectChartInfo.actualWorkingHours /
                            projectChartInfo.estimatedWorkingHours) *
                          100
                    "
                    :stroke-width="10"
                    :show-text="false"
                  ></el-progress>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="progress-box">
            <div class="title">
              {{
                $lange == "en" ? "Task completion comparison" : "任务完成对比图"
              }}
            </div>
            <div class="show-progress">
              <div class="child progress-default">
                <p>
                  {{ $lange == "en" ? "Total task" : "任务总数" }}
                  {{ projectChartInfo.tasksNumber }}个
                </p>
                <div class="progress-content">
                  <el-progress
                    :percentage="100"
                    :stroke-width="10"
                    :show-text="false"
                  ></el-progress>
                </div>
              </div>
              <div class="child">
                <p>
                  {{ $lange == "en" ? "Quantity" : "完成任务" }}
                  {{ projectChartInfo.completeTasksNumber }}个
                </p>
                <div class="progress-content">
                  <el-progress
                    :percentage="
                      projectChartInfo.tasksNumber === 0
                        ? 0
                        : (projectChartInfo.completeTasksNumber /
                            projectChartInfo.tasksNumber) *
                          100
                    "
                    :stroke-width="10"
                    :show-text="false"
                  ></el-progress>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="progress-box">
            <div class="title">
              {{ $lange == "en" ? "Number of requests " : "请求次数" }}
            </div>
            <div class="show-progress">
              <div class="child">
                <p>
                  {{ $lange == "en" ? "Processing" : "处理中" }}
                  {{ projectChartInfo.processing }}个
                </p>
                <div class="progress-content color-blue">
                  <el-progress
                    :percentage="
                      projectChartInfo.total === 0
                        ? 0
                        : (projectChartInfo.processing /
                            projectChartInfo.total) *
                          100
                    "
                    :stroke-width="10"
                    :show-text="false"
                  ></el-progress>
                </div>
              </div>
              <div class="child">
                <p>
                  {{ $lange == "en" ? "Closed" : "已关闭" }}
                  {{ projectChartInfo.closed }}个
                </p>
                <div class="progress-content color-gold">
                  <el-progress
                    :percentage="
                      projectChartInfo.total === 0
                        ? 0
                        : (projectChartInfo.closed / projectChartInfo.total) *
                          100
                    "
                    :stroke-width="10"
                    :show-text="false"
                  ></el-progress>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" justify="between" :gutter="5">
        <el-col :span="10">
          <div class="echarts-box">
            <div class="title flex-between" style="padding: 14px 20px">
              <p>{{ $lange == "en" ? "Requests Tracking" : "请求跟踪" }}</p>
            </div>
            <template v-if="isCreate">
              <div class="not-data flex-between">
                {{ $lange == "en" ? "No Data" : "暂无数据" }}
              </div>
            </template>
            <template v-else>
              <div class="echarts" id="echarts-work"></div>
            </template>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="echarts-box">
            <div class="title flex-between">
              <p>安装支出费用占比</p>
              <!-- <el-date-picker
                value-format="yyyy"
                v-model="workPieDate"
                align="right"
                type="year"
                size="mini"
                :placeholder="$lange == 'en' ? 'Please Select Year' : '选择年'"
              ></el-date-picker> -->
            </div>
            <template v-if="isCreate">
              <div class="not-data flex-between">
                {{ $lange == "en" ? "No Data" : "暂无数据" }}
              </div>
            </template>
            <template v-else>
              <div
                class="echarts"
                id="echarts-work-pie"
                style="padding: 0"
              ></div>
            </template>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="echarts-box">
            <div class="title flex-between" style="padding: 14px 20px">
              <p>{{ $lange == "en" ? "Requests by Machine" : "机器问题数" }}</p>
            </div>
            <template v-if="isCreate">
              <div class="not-data flex-between">
                {{ $lange == "en" ? "No Data" : "暂无数据" }}
              </div>
            </template>
            <template v-else>
              <div class="lists">
                <div class="list-title flex-between">
                  <p>{{ $lange == "en" ? "Ranking" : "排名" }}</p>
                  <p class="list-child-wid">
                    {{ $lange == "en" ? "Machine" : "机器" }}
                  </p>
                  <p>{{ $lange == "en" ? "Number of Request" : "请求次数" }}</p>
                </div>
                <template
                  v-if="
                    projectChartInfo.machineProblemList &&
                    projectChartInfo.machineProblemList.length > 0
                  "
                >
                  <div
                    class="list-context flex-between"
                    v-for="(item, idx) in projectChartInfo.machineProblemList"
                  >
                    <p>{{ idx + 1 }}</p>
                    <p
                      class="row-clip list-child-wid row-clip"
                      :title="item.machineName"
                    >
                      {{ item.machineName }}
                    </p>
                    <p class="list-progress flex-between">
                      <span>{{ item.number }}</span>
                      <el-progress
                        :percentage="
                          projectChartInfo.machineProblemTotal === 0
                            ? 0
                            : (item.number /
                                projectChartInfo.machineProblemTotal) *
                              100
                        "
                        :show-text="false"
                      ></el-progress>
                    </p>
                  </div>
                </template>
                <div class="list-context flex-between" v-else>
                  <p style="opacity: 0">0</p>
                  <p class="row-clip list-child-wid row-clip" :title="$lange == 'en' ? 'No Data' : '暂无数据'">
                    {{ $lange == "en" ? "No Data" : "暂无数据" }}
                  </p>
                  <p class="list-progress flex-between" style="opacity: 0">
                    <span>0</span>
                    <el-progress
                      :percentage="0"
                      :show-text="false"
                    ></el-progress>
                  </p>
                </div>
              </div>
            </template>
          </div>
        </el-col>
      </el-row>
      <div class="table-box">
        <div class="table-title flex-between">
          <div class="left">
            <div class="label">
              {{ $lange == "en" ? "History Request" : "历史请求明细" }}
            </div>
          </div>
          <div class="show-btn" @click="showTable('historyTableShow')">
            <template v-if="$lange == 'en'">{{
              historyTableShow ? "hide" : "show"
            }}</template>
            <template v-else>{{ historyTableShow ? "收起" : "展开" }}</template>
          </div>
        </div>
        <el-collapse-transition>
          <div class="table-content" v-show="historyTableShow">
            <cc-table
              :config="historyTableConfig"
              :params="historyTableParams"
              :load-data="historyTableParams.jobId.length > 0"
            ></cc-table>
          </div>
        </el-collapse-transition>
      </div>
    </template>
    <el-dialog
      :title="$lange == 'en' ? 'Add Annex' : '添加附件'"
      :visible.sync="dialogFlag"
      width="60%"
      append-to-body
    >
      <el-form ref="form" :model="accessory" label-width="100px">
        <el-form-item
          :label="$lange == 'en' ? 'Annex Name' : '附件名'"
          required="true"
        >
          <el-input v-model="accessory.fileName"></el-input>
        </el-form-item>
        <el-form-item
          :label="$lange == 'en' ? 'Upload' : '文件上传'"
          required="true"
          style="line-height: 0"
        >
          <cc-uploader
            :config="uploaderConf2"
            v-model="accessory.accessoryUrl"
          />
        </el-form-item>

        <el-button type="primary" size="mini" @click="postFile">{{
          $lange == "en" ? "Save" : "保存"
        }}</el-button>
      </el-form>
    </el-dialog>

    <el-dialog
      :visible.sync="detailsDialog"
      :fullscreen="true"
      :title="$lange == 'en' ? 'Details' : '详情'"
      append-to-body
    >
      <template v-if="detailsDialog">
        <OrderDescriptionView
          :orderIdV2="detailsId"
          :isDialog="true"
        ></OrderDescriptionView>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import UserCard from "../../../components/UserCard";
import pdf_icon from "../../../../src/assets/PDF.png";
import Echarts from "echarts";
import moment from "moment";
import utils from "../../../utils/utils";
import OrderDescriptionView from "../../order/OrderDescription.vue";
import axios from "axios";
export default {
  name: "ProductComponent",
  props: {
    isCreate: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    workPieDate: {
      handler() {
        this.workPieInit();
      },
    },
  },
  data() {
    return {
           detailsDialog: false,
      detailsId: "",
      projectChartInfo: {
        estimatedWorkingHours: 0,
        actualWorkingHours: 0,
        tasksNumber: 0,
        completeTasksNumber: 0,
        processing: 0,
        closed: 0,
        total: 0,
        machineProblemTotal: 0,
        machineProblemList: [],
      }, //机器问题数、工时对比图、任务完成对比图、请求次数的数据
      projectId: "",
      fileSearchValue: "",
      workPieDate: "",
      uploaderConf2: this.$uploadUtils.config,
      accessoryInfoList: [],
      enclosureSearch: "",
      accessory: {
        fileName: "",
        accessoryUrl: "",
      },
      dialogFlag: false,
      pdf_icon: pdf_icon,
      cardConfig: {
        api: "admin/fsb/project/save",
        image: "",
        isProject: true,
        jobId: "",
        status: "",
        formLists: [
          //表单内容
          {
            name: "客户",
            value: "",
            type: "input",
            disabled: true,
            key: "customerName",
          },
          {
            name: "Project No.",
            type: "input",
            value: "",
            required: true,
            key: "fasId",
          },
          {
            name: "项目经理",
            type: "select",
            value: "",
            managerId: "",
            required: true,
            key: "managerName",
          },
          {
            name: "产品线",
            value: "",
            disabled: true,
            type: "input",
            key: "productLine",
          },
          {
            name: "速度",
            value: "",
            disabled: true,
            type: "input",
            key: "speed",
          },
          {
            name: "幅宽",
            value: "",
            disabled: true,
            type: "input",
            key: "breadth",
          },
          {
            name: "堆叠层数",
            type: "input",
            value: "",
            disabled: true,
            key: "stackedLayers",
          },
          {
            name: "瓦楞层数",
            value: "",
            disabled: true,
            type: "input",
            key: "corrugatedLayers",
          },
          {
            name: "项目时间",
            type: "daterange",
            required: true,
            value: `${moment(new Date()).format("YYYY-MM-DD")}~${moment(
              new Date().getTime() + 7776000000
            ).format("YYYY-MM-DD")}`,
            key: "projectTime",
          },
        ],
        postKey: ["jobId", "projectTime", "fasId", "managerName"],
      },
      workDate: "2019", //工单请求情况 柱状图 日期
      workPicDate: "2019", //工单请求情况 圆饼图 日期
      historyTableShow: false,
      historyTableParams: {
        jobId: "",
        pageSize: 999,
      },
      historyTableConfig: {
        api: "admin/fsb/work/order/query",
        showPager: false,
        // dragState: true,
        columns: [
          {
            prop: "id",
            lable: "Care ID",
          },
          {
            prop: "jobId",
            lable: "Job ID",
          },
          {
            prop: "priority",
            lable: "Priority",
          },
          {
            prop: "product.status",
            lable: "ProductStatus",
            // type: "tag",
            // options: [
            //   { tagType: "info", text: "新增" },
            //   { tagType: "warning", text: "安装" },
            //   { tagType: "success", text: "保内" },
            //   { tagType: "danger", text: "保外" },
            // ],
            type: "constant",
            constantConfig: {
              code: "productStatus",
              api: "admin/dict/pageTree",
              opts: { 0: "info", 1: "warning", 2: "success", 3: "danger" },
            },
            minWidth: this.$lange == "en" ? 130 : 80,
          },

          {
            prop: "customer.customerName",
            lable: "Customer",
          },
          {
            prop: "handlerName",
            lable: "Contact",
          },
          {
            prop: "machine.machineModel",
            lable: "Machine",
          },
          {
            prop: "machine.fiCom",
            lable: "COM",
          },
          {
            prop: "title",
            lable: "Subject",
          },
          {
            prop: "userName",
            lable: "CareManager",
          },
          {
            prop: "status",
            lable: "Status",
            type: "constant",
            constantConfig: {
              code: "orderStatus",
              api: "admin/dict/pageTree",
              opts: {
                0: "info",
                1: "warning",
                2: "warning",
                3: "success",
                4: "success",
                5: "info",
              },
            },
          },
          {
            prop: "malfunctionAttribute.name",
            lable: "Classification",
          },
          {
            lable: "Last update",
            render: (row) => {
              return moment(row.updateTime).format("YYYY-MM-DD");
            },
          },
          {
            lable: "Created",
            render: (row) => {
              return moment(row.createTime).format("YYYY-MM-DD");
            },
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Operation" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "Details" : "详情",
            click: (row) => {
              this.detailsId = row.id;
              this.detailsDialog = true;
              // this.$router.push({
              //   path: "/admin/order/des",
              //   query: {
              //     id: row.id,
              //   },
              // });
            },
          },
        ],
      },
      fasId: 0,
    };
  },
  methods: {
    fileSearch(res) {
      for (let i in this.accessoryInfoList) {
        this.accessoryInfoList[i].redName = "";
        if (this.accessoryInfoList[i].fileName.indexOf(res) > -1) {
          this.accessoryInfoList[i].redName = this.accessoryInfoList[
            i
          ].fileName.replace(res, `<span style="color: red">${res}</span>`);
        }
      }
    },
    showDialog() {
      if (this.isCreate) {
        this.$message({
          type: "warning",
          message: "项目未创建不可添加附件",
        });
        return false;
      }
      this.dialogFlag = true;
    },
    renderDate(date, format) {
      date = new Date(date);
      let res = utils.getFormatDate(date, format);
      return res;
    },
    postFile() {
      let data = this.accessory;
      data.objId = this.cardConfig.jobId;
      data.objType = "product";
      if (data.fileName.length < 1) {
        this.$message({
          message: "请输入文件名",
          type: "warning",
        });
        return false;
      }
      if (data.accessoryUrl.length < 1) {
        this.$message({
          message: "请上传附件",
          type: "warning",
        });
        return false;
      }
      this.ccRequest
        .do("admin/fsb/accessory/save", data, "POSTJSON")
        .then((res) => {
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.dialogFlag = false;
          this.getProject();
          this.accessory = {
            fileName: "",
            accessoryUrl: "",
          };
        })
        .catch((res) => {
          this.$message.error(res.response.data.message);
        });
    },
    showTable(tableType) {
      if (this.isCreate) {
        this.$alert("客户未创建，暂无数据", "温馨提示");
        return false;
      }
      this[tableType] = !this[tableType];
    },
    workInit() {
      let data = {
        projectId: this.projectId,
        // projectId: "1167065294423826433",
      };
      this.ccRequest
        .do("admin/fsb/project/projectChartInfo", data, "GET")
        .then((res) => {
          res.total = res.processing * 1 + res.closed * 1;
          res.machineProblemTotal = 0;
          for (let i in res.machineProblemList) {
            res.machineProblemTotal += res.machineProblemList[i].number;
          }
          this.projectChartInfo = res;
          let source = [["product", "已关闭", "处理中"]];
          let barWidth = 22;
          for (let j = 0; j < 12; j++) {
            //初始化12个月的值
            source.push([`${j + 1}月`, 0, 0]);
          }
          for (let i in res.workOrderInfoList) {
            barWidth -= 1;
            let item = res.workOrderInfoList[i];
            source[item.month] = [
              source[item.month][0],
              item.closed,
              item.processing,
            ];
          }
          let option = {
            legend: {},
            tooltip: {},
            dataset: {
              source: source,
              itemStyle: {},
            },
            xAxis: { type: "category" },
            yAxis: {},
            // Declare several bar series, each will be mapped
            // to a column of dataset.source by default.
            series: [
              { type: "bar", color: "#d9001b", barWidth: `${barWidth}px` },
              { type: "bar", color: "#49a9ee", barWidth: `${barWidth}px` },
            ],
          };
          let workCanvas = Echarts.init(
            document.getElementById("echarts-work")
          );
          workCanvas.setOption(option);
        });
    },

    workPieInit() {
      let data = {
        projectId: this.projectId,
        // projectId: "1167065294423826433",
        // year: this.workPieDate,
      };
      this.ccRequest
        .do("admin/fsb/project/installationExpenditure", data, "GET")
        .then((res) => {
          let option = {
            tooltip: {
              trigger: "item",
              /**
               * @b name
               * @c value
               * @d angle
               * */
              formatter: "{b} : {c} ({d}%)",
            },
            textStyle: {
              color: "#aaa",
            },
            series: [
              {
                type: "pie",
                radius: "65%",
                center: ["50%", "50%"],
                data: [
                  {
                    value: res.partsFee / 100 || 0,
                    name: `配件费费用总计`,
                    label: {
                      formatter: "占比: {d} \n\n {b} : {c}",
                    },
                    itemStyle: {
                      color: "#49a9ee",
                    },
                  },
                  {
                    value: res.serviceFee / 100 || 0,
                    name: `服务费用总计`,
                    label: {
                      formatter: "占比: {d} \n\n {b} : {c}",
                    },
                    itemStyle: {
                      color: "#e6c163",
                    },
                  },
                  {
                    value: res.travelFee / 100 || 0,
                    name: `差旅费用总计`,
                    label: {
                      formatter: "占比: {d} \n\n {b} : {c}",
                    },
                    itemStyle: {
                      color: "#95f204",
                    },
                  },
                  {
                    value: res.otherFee / 100 || 0,
                    name: "其他总计",
                    label: {
                      formatter: "占比: {d} \n\n {b} : {c}",
                    },
                    itemStyle: {
                      color: "#81d3f8",
                    },
                  },
                ],
                itemStyle: {
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
          };
          let workPicCanvas = Echarts.init(
            document.getElementById("echarts-work-pie")
          );
          workPicCanvas.setOption(option);
        });
    },
    initEcharts() {
      //如果是创建页面, 无需实例化图标
      if (this.isCreate) {
        return false;
      }
      this.workInit();
      let year = `${new Date().getFullYear()}`;
      this.workPieDate = year;
    },
    getProject() {
      let data = {
        fasId: this.fasId,
      };
      this.ccRequest
        .do("admin/fsb/project/getByFasId", data, "GET")
        .then((res) => {
          for (let j in this.cardConfig.formLists) {
            if (
              this.cardConfig.formLists[j].key == "customerName" &&
              res.product
            ) {
              if (res.product.customer) {
                this.cardConfig.formLists[
                  j
                ].value = `${res.product.customer.customerName} `;
              } else {
                this.cardConfig.formLists[j].value = `---`;
              }
            }
            for (let i in res.product) {
              if (
                this.cardConfig.formLists[j].key &&
                this.cardConfig.formLists[j].key == i
              ) {
                this.cardConfig.formLists[j].value = res.product[i];
              }
              if (this.cardConfig.formLists[j].key == "projectTime") {
                this.cardConfig.formLists[j].value = res.projectTime;
              }
            }
            if (this.cardConfig.formLists[j].key == "fasId") {
              this.cardConfig.formLists[j].value = res.fasId;
            }
            if (this.cardConfig.formLists[j].key == "managerName") {
              this.cardConfig.formLists[j].value = res.managerName;
              this.cardConfig.formLists[j].managerId = res.managerId;
            }
          }
          for (let i in res.accessoryInfoList) {
            res.accessoryInfoList[i].redName = "";
          }
          this.cardConfig.jobId = res.jobId;
          this.historyTableParams.jobId = res.jobId;
          this.cardConfig.status = res.status;
          this.cardConfig.image = res.imageUrl;
          this.cardConfig.id = res.id;
          this.accessoryInfoList = res.accessoryInfoList;
          this.projectId = res.id;
          this.initEcharts();
        });
    },
    getData() {
      this.getProject();
    },
    downloadFile(data, name) {
      if (data.accessoryUrl.length < 1) {
        return this.$message({
          type: "warning",
          message: "文件错误,请重新上传",
        });
      }
      if (data.fileName.indexOf("pdf") > -1) {
        let pData = {
          url: data.accessoryUrl,
        };
        return this.ccRequest
          .do("admin/fsb/file/aliyun/privateDownloadUrl", pData, "GET")
          .then((res) => {
            window.open(res.url)
            // axios({
            //   method: "get",
            //   url: res.url,
            //   headers: {
            //     "Content-Disposition": "attachment",
            //   },
            // }).then((res2) => {
            //   this.$message({
            //     type: "success",
            //     message: "文件已下载",
            //   });
            // });
          });
      }

      this.$message({
        type: "success",
        message: "文件已下载",
      });
      let imageType = ["png", "jpg", "jpeg", "webp"];
      for (let i in imageType) {
        if (data.fileName.indexOf(imageType[i]) > -1) {
          this.downloadImage(data.accessoryUrl, name);
          return false;
        }
      }
      let a = document.createElement("a");
      a.href = data.accessoryUrl;
      a.download = name;
      a.click();
    },
    downloadImage(imgsrc, name) {
      // 下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); // 得到图片的base64编码数据
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    delFile(item, index) {
      this.$confirm("此操作会删除该附件, 是否确定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            id: item.id,
          };
          this.ccRequest
            .do("admin/fsb/accessory/delete", data, "GET")
            .then((res) => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.accessoryInfoList.splice(index, 1);
              this.getProject();
            });
        })
        .catch(() => {
          // this.$message({
          //     type: 'info',
          //     message: '已取消删除'
          // });
        });
    },
    checkLanguage() {
      if (this.$lange == "en") {
        this.cardConfig = {
          api: "admin/fsb/project/save",
          image: "",
          isProject: true,
          jobId: "",
          status: "",
          formLists: [
            //表单内容
            {
              name: "Customer",
              value: "",
              type: "input",
              disabled: true,
              key: "customerName",
            },
            {
              name: "Project No.",
              type: "input",
              value: "",
              placeholder: this.$lange == "en" ? "Please Select" : "请输入",
              key: "fasId",
            },
            {
              name: "Project Manager",
              type: "select",
              value: "",
              managerId: "",
              placeholder: this.$lange == "en" ? "Please Select" : "请输入",
              key: "managerName",
            },
            {
              name: "Product Line",
              value: "",
              disabled: true,
              type: "input",
              key: "productLine",
            },
            {
              name: "Speed",
              value: "",
              disabled: true,
              type: "input",
              key: "speed",
            },
            {
              name: "Width",
              value: "",
              disabled: true,
              type: "input",
              key: "breadth",
            },
            {
              name: "Staker Level",
              type: "input",
              value: "",
              disabled: true,
              key: "stackedLayers",
            },
            {
              name: "Flutes",
              value: "",
              disabled: true,
              type: "input",
              key: "corrugatedLayers",
            },
            {
              name: "Project Time",
              type: "daterange",
              value: "2019-07-09~2022-09-08",
              key: "projectTime",
            },
          ],
          postKey: ["jobId", "projectTime", "fasId", "managerName"],
        };
      }
    },
  },
  mounted() {
    this.checkLanguage();
    if (this.isCreate) {
      let disabledArr = [
        "productLine",
        "speed",
        "breadth",
        "stackedLayers",
        "corrugatedLayers",
        "customerName",
      ];
      this.cardConfig.postKey = [];
      for (let j in this.cardConfig.formLists) {
        // if(this.cardConfig.formLists[j].key == "customerName"){
        //     this.cardConfig.formLists[j].key = "customerId";
        //     this.cardConfig.formLists[j].type = "select";
        // }

        this.cardConfig.postKey.push(this.cardConfig.formLists[j].key);
        if (disabledArr.indexOf(this.cardConfig.formLists[j].key) < 0) {
          this.cardConfig.formLists[j].disabled = false;
        } else {
          this.cardConfig.formLists[j].disabled = true;
        }
      }
      return false;
    }
    this.fasId = this.$route.query.fasId;
    this.getData();
  },
  components: {
    UserCard,
    OrderDescriptionView,
  },
};
</script>
<style >
.project .el-dialog__body {
padding: 10px 20px 30px 20px;
}
</style>
<style lang="scss">
.progress-box {
  .el-progress {
    width: 280px;
  }
}

.progress-default {
  .el-progress-bar__inner {
    background: #ff7100;
  }
}

.color-blue {
  .el-progress-bar__inner {
    background: #49a9ee;
  }
}

.color-gold {
  .el-progress-bar__inner {
    background: #ffd86e;
  }
}
</style>

<style scoped lang="scss">
.project {
  .table-box {
    background: #ffffff;
    margin-top: 5px;

    .table-title {
      padding: 10px 20px;

      .left {
        display: flex;
        align-items: center;

        .add-contacts {
          font-size: 12px;
          padding: 5px;
          margin-left: 15px;
        }
      }

      .show-btn {
        font-size: 12px;
        background: #e4e4e4;
        padding: 3px 10px;
        cursor: pointer;
      }
    }
  }

  .enclosure {
    height: 100%;
    max-height: 307px;
    overflow-y: scroll;
    background: #ffffff;
    padding: 10px 20px;
    box-sizing: border-box;
    .title {
    }

    .list-box {
      display: flex;
      flex-direction: column;
      .list {
        margin-top: 10px;

        .pdf-name {
          width: 120px;
        }
        img {
          display: block;
          width: 30px;
        }
      }
    }
  }

  .echarts-box {
    margin-top: 5px;
    background: #ffffff;
    /*标题*/
    .title {
      border-bottom: 1px solid #e4e4e4;
      padding: 10px 20px;
    }

    /*图表*/
    .echarts {
      padding: 20px;
      height: 360px;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
    }

    /*表格内容*/
    .lists {
      height: 360px;
      overflow: auto;
      padding: 0 20px;

      p {
        min-width: 80px;
      }

      & > * > p {
        padding: 10px 0;

        &:last-child {
          flex: 1;
        }

        &:first-child {
          text-align: center;
        }

        &:nth-child(2) {
          margin: 0 10px;
        }
      }

      .list-child-wid {
        width: 120px;
      }

      .list-title {
        color: #cccccc;
        border-bottom: 1px solid #e4e4e4;
      }

      .list-context {
        &:not(:last-child) {
          border-bottom: 1px solid #e4e4e4;
        }

        .list-progress {
          span {
            margin-right: 10px;
          }
        }
      }
    }

    /*无数据的时候显示*/
    .not-data {
      height: 360px;
      justify-content: center;
      font-size: 22px;
      color: #e4e4e4;
    }
  }

  .progress-box {
    background: #ffffff;
    padding: 20px;
    margin-top: 5px;

    .title {
      font-size: 24px;
      margin-bottom: 10px;
    }

    .show-progress {
      .child {
        margin-top: 20px;
        font-size: 14px;
        color: #c9c9c9;
        display: flex;
        align-items: center;

        > p {
          min-width: 130px;
        }

        .progress-content {
          flex: 1;
        }
      }
    }
  }
}
</style>
